export enum DocumentTypeEnum {
  BANK_ACCOUNT = 'bank-account',
  SECOND_BANK_STATEMENT = 'second-bank-statement',
  PROOF_OF_ADDRESS = 'proof-of-address',
  RFC = 'rfc',
  INITIAL_CONTRIBUTION_PROOF = 'initial-contribution-proof',
}
